<template>
  <div class="row justify-content-center">
    <div class="col-sm-9 col-md-8 col-lg-6 col-xl-4">
      <form>
        <div class="form-group">
          <label for="userEmail">{{ $t("forms.email.label") }}</label>
          <input
            type="email"
            :class="['form-control', valid.email ? 'is-valid' : 'is-invalid']"
            id="userEmail"
            aria-describedby="userEmailHelp"
            :placeholder="$t('forms.email.placeholder')"
            v-model="user.email"
            @input="validateEmail()"
          />
          <small id="userEmailHelp" class="form-text text-muted">{{
            $t("forms.email.helper")
          }}</small>
        </div>

        <div class="form-group">
          <label for="userPassword">{{ $t("forms.password.label") }}</label>
          <input
            type="password"
            :class="[
              'form-control',
              valid.password ? 'is-valid' : 'is-invalid'
            ]"
            id="userPassword"
            aria-describedby="userPasswordHelp"
            :placeholder="$t('forms.password.placeholder')"
            v-model="user.password"
            @input="validatePassword()"
          />
          <small id="userPasswordHelp" class="form-text text-muted">{{
            $t("forms.password.helper")
          }}</small>
        </div>

        <div class="form-group" v-if="isNew">
          <label for="pantryId">{{ $t("forms.pantryId.label") }}</label>
          <input
            type="input"
            :class="[
              'form-control',
              valid.pantryId ? 'is-valid' : 'is-invalid'
            ]"
            id="pantryId"
            aria-describedby="pantryIdHelp"
            :placeholder="$t('forms.pantryId.placeholder')"
            v-model="user.pantryId"
            @input="validatePantryId()"
          />
          <small id="pantryIdHelp" class="form-text text-muted">{{
            $t("forms.pantryId.helper")
          }}</small>
        </div>

        <div class="d-flex justify-content-center">
          <button
            type="submit"
            class="btn btn-success"
            :disabled="!validForm"
            :aria-disabled="!validForm"
            @click.prevent="submit"
          >
            {{ isNew ? $t("user.register") : $t("user.login") }}
          </button>
          <div class="btn btn-danger ml-3" @click="$router.go(-1)">
            {{ $t("buttons.back") }}
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { randomKey } from "./../../tools";

export default {
  name: "UserForm",
  props: {
    isNew: { type: Boolean, default: false },
    user: {
      type: Object,
      default() {
        return { email: "", password: "", pantryId: "" };
      }
    }
  },
  data() {
    return {
      valid: {
        email: false,
        password: false,
        pantryId: true
      }
    };
  },
  computed: {
    validForm() {
      for (let property in this.valid) {
        if (!this.valid[property]) {
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    validateEmail() {
      this.valid.email =
        this.user.hasOwnProperty("email") &&
        !!this.user.email.match(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g
        );
    },
    validatePassword() {
      this.valid.password =
        this.user.hasOwnProperty("password") &&
        !!this.user.password.match(
          // /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/g
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/g
        );
    },
    validatePantryId() {
      this.valid.pantryId =
        this.user.hasOwnProperty("pantryId") &&
        (this.user.pantryId === "" ||
          !!this.user.pantryId.match(/^([A-Za-z0-9=\+/]){24}$/g));
    },
    submit() {
      if (this.validForm) {
        if (this.isNew && this.user.pantryId === "") {
          this.user.pantryId = randomKey();
        }
        this.$emit("userSubmitted", this.user);
      }
    }
  },
  created() {
    this.validateEmail();
    this.validatePassword();
  }
};
</script>

<style scoped></style>
